export default __webpack_public_path__ + "83fe677c584683439a3c7a8f460c14fe.svg";